import { useEffect } from 'react';
import * as H from 'history';
import { setQueryStringParameter } from '../utils/query-hepler';

const useHistoryInitialize = (props: {
  region: string;
  history: H<unknown>;
}) => {
  const { region, history } = props;
  useEffect(() => {
    // For Clover, we need to append shop_region param on the URL.
    // detecting url when entering pc for the first time.
    let searchURLParam = new URLSearchParams();
    let shopRegion = searchURLParam.get('shop_region');
    if (!shopRegion) {
      setQueryStringParameter('shop_region', region || undefined);
    }
    // internal operational platform, detecting URL changes.
    history.listen(_e => {
      searchURLParam = new URLSearchParams();
      shopRegion = searchURLParam.get('shop_region');
      if (!shopRegion) {
        setQueryStringParameter('shop_region', region || undefined);
      }
    });
  }, [region]);
};
export default useHistoryInitialize;
